<div class="page-header"><h1 class="page-title">Search History</h1></div>

<div class="row mt-3">
	<div class="col">
		<app-table
			[downloadHeading]="'Agent Search History: ' + agent.username"
			[downloadName]="'agent_search_history_' + agent.username"
			[data]="results"
			[headerClass]="'table-info'"
			[columns]="columnRef"
			[loading]="loading"
			(onUpdateRequired)="doFetchResults($event)"
			>
			<ng-template #date let-row="row">
				<td>{{row.date | date: 'yyyy-MM-dd HH:mm:ss'}}</td>
			</ng-template>
			<ng-template #filters let-row="row">
				<ng-container [ngSwitch]="row.recordType">
					<td>
						<!-- [{{row.filters | json}}] -->
						<ul>
							<li *ngFor="let filter of row.filters">
								{{filter.filterName}}: {{filter.filterValue}}
							</li>
						</ul>
					</td>
				</ng-container>
			</ng-template>
		</app-table>
	</div>
</div>
